import './Notification.scss'
import Button from '../UI/Button.jsx'

interface NotificationComponentProps {
  closeToast: () => void
  status?: 'success' | 'error' | 'info'
  title: string
  description: string
  acceptText?: string
  acceptHandler?: () => void
  rejectText?: string
  rejectHandler?: () => void
}

function NotificationComponent({
  closeToast,
  status,
  title,
  description,
  acceptText,
  acceptHandler,
  rejectText,
  rejectHandler
}: NotificationComponentProps) {

  const statusImg = (
    <img src={`/${status}.svg`} alt={status} className="notification-status" />
  )

  const accepttext = acceptText ? acceptText : 'Хорошо'
  const rejecttext = rejectText ? rejectText : 'Нет'

  const dialogButtons = (
    <div className='dialogButtons'>
      <Button contrastStyle className='dialogButton' onClick={acceptHandler}>{accepttext}</Button>
      <Button className='dialogButton' onClick={rejectHandler}>{rejecttext}</Button>
    </div>
  )

  const statusImage = status ? statusImg : null
  const contentDialog = acceptHandler ? dialogButtons : null

  return (
    <div className="notification">
      {statusImage}
      <div className="notification-flex">
        <div className="notification-title">
          <div className="notification-title-text">
            {title}
          </div>
          <img
            src="/UI/closeIconBlack.svg"
            alt="closeButton"
            className="notification-title-button"
            onClick={() => closeToast()}
          />
        </div>
        <div className="notification-description">{description}</div>
        {contentDialog}
      </div>
    </div>
  )
}

export default NotificationComponent
